/* @flow */
import React from 'react';
import ReactDOM from 'react-dom';
import makeRoutes from './routes';
import Root from './containers/Root';
import counterpart from 'counterpart';
import Auth from 'interactive-solutions/authentication';
import store, { history } from 'store';
require('es6-promise').polyfill();
require('babel-polyfill');

import swedishTranslations from 'lang/lang-se';
import englishTranslations from 'lang/lang-en';

import CookieUtils from 'frilans-finans/utils/cookie-utils';

counterpart.registerTranslations('en', englishTranslations);
counterpart.registerTranslations('se', swedishTranslations);
counterpart.setLocale('se');

// Configure the authentication system
Auth.init({
  endpoints: {
    token: 'https://ff-lumen-api-dev.herokuapp.com/auth/accesstoken'
  },
  store: store
});

// Now that we have the Redux store, we can create our routes. We provide
// the store to the route definitions so that routes have access to it for
// hooks such as `onEnter`.
const routes = makeRoutes(store);

// Now that redux and react-router have been configured, we can render the
// React application to the DOM!
ReactDOM.render(
  <Root history={history} routes={routes} store={store}/>,
  document.getElementById('root')
);

CookieUtils.setLanguageFromCookie(store);



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/